import { Subject } from "rxjs";

const clickEvent = new Subject<string>();

export const eventService = {
  sendClick: (text: string) => clickEvent.next(text),
  getClickStream: () => clickEvent.asObservable(),
};
